import { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { detectLocale } from "./i18n";
import { SHELL_PAGES } from "./config/navigation";
import { SiteSettingsProvider } from "./lib/siteSettings";
import LocaleLayout from "./pages/LocaleLayout";
import Home from "./pages/Home";
import ShellPage from "./pages/ShellPage";
import VehicleDetail from "./pages/VehicleDetail";
import InventoryPage from "./pages/InventoryPage";
import CompanyPage from "./pages/CompanyPage";
import NotFound from "./pages/NotFound";
import SourcingPage from "./pages/SourcingPage";
import SellPage from "./pages/SellPage";
import ContactPage from "./pages/ContactPage";
import ExportPage from "./pages/ExportPage";
import LegalPage from "./pages/LegalPage";

const AdminApp = lazy(() => import("./admin/AdminApp"));
const RootRedirect = () => <Navigate to={`/${detectLocale()}`} replace />;

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/admin/*" element={<Suspense fallback={<div className="min-h-screen bg-paper" />}><AdminApp /></Suspense>} />
          <Route path="/:lang" element={<SiteSettingsProvider><LocaleLayout /></SiteSettingsProvider>}>
            <Route index element={<Home />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="inventory/sold" element={<InventoryPage key="sold" scope="sold" />} />
            <Route path="inventory/:slug" element={<VehicleDetail />} />
            <Route path="company" element={<CompanyPage />} />
            <Route path="sourcing" element={<SourcingPage />} />
            <Route path="sell" element={<SellPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="export" element={<ExportPage />} />
            <Route path="privacy" element={<LegalPage key="privacy" page="privacy" />} />
            <Route path="legal" element={<LegalPage key="legal" page="legal" />} />
            {SHELL_PAGES.map((p) => (
              <Route key={p} path={p} element={<ShellPage page={p} />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
